import { render, staticRenderFns } from "./PopUpAddMaterials.vue?vue&type=template&id=0f38226d&"
import script from "./PopUpAddMaterials.vue?vue&type=script&lang=js&"
export * from "./PopUpAddMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f38226d')) {
      api.createRecord('0f38226d', component.options)
    } else {
      api.reload('0f38226d', component.options)
    }
    module.hot.accept("./PopUpAddMaterials.vue?vue&type=template&id=0f38226d&", function () {
      api.rerender('0f38226d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/vistas/modals/PopUpAddMaterials.vue"
export default component.exports